import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const FALLBACK = { name: "Secretariat", tagline: "Digital Records Office", has_logo: false, logo_version: "" };
let cache = null;
const subs = new Set();

export const loadBranding = async () => {
  const r = await api.get("/public/branding");
  cache = r.data;
  subs.forEach((f) => f(cache));
  return cache;
};

export function useBranding() {
  const [b, setB] = useState(cache);
  useEffect(() => {
    subs.add(setB);
    if (!cache) loadBranding().catch(() => {});
    return () => subs.delete(setB);
  }, []);
  return b || FALLBACK;
}

export const logoUrl = (b) => `${API}/public/branding/logo?v=${encodeURIComponent(b.logo_version || "")}`;
